import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from '../../components/page/page.component';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { LoadableContentComponent } from 'src/app/general/components/loadable-content/loadable-content.component';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { FieldContainerDirective } from 'src/app/general/directives/field/field-container.directive';
import { FieldDirective } from 'src/app/general/directives/field/field.directive';
import { EnvironmentUtil } from '../../util/environment-util';
import { MatRadioModule } from '@angular/material/radio';
import { HeadingComponent } from 'src/app/general/components/heading/heading.component';
import { DeviceService } from 'src/app/general/services/device.service';
import { TableLayoutComponent } from 'src/app/general/components/table-layout/table-layout.component';
import { NavigationService } from '../../services/navigation.service';
import { BusinessHeaderComponent } from '../../components/business-header/business-header.component';

@Component({
  selector: 'app-qr-codes-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    LoadableContentComponent,
    BusinessHeaderComponent,
    LocationHeaderComponent,
    TranslateModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    FieldContainerDirective,
    FieldDirective,
    ReactiveFormsModule,
    ActionComponent,
    MatRadioModule,
    HeadingComponent,
    TableLayoutComponent
  ],
  templateUrl: './qr-codes-page.component.html',
  styleUrls: ['./qr-codes-page.component.css']
})
export class QrCodesPageComponent {
  businessId: string;
  locationId: string;

  downloadQrCodesActionUrl;
  qrCodeSizeField: FormControl;
  languageField: FormControl;
  themeField: FormControl;

  constructor(
      public sessionService: SessionService,
      public deviceService: DeviceService,
      private activatedRoute: ActivatedRoute,
      private navigationService: NavigationService) {
    this.locationId = '';
    this.businessId = '';

    this.downloadQrCodesActionUrl = '';
    this.qrCodeSizeField = new FormControl("small");
    this.languageField = new FormControl("en");
    this.themeField = new FormControl("light");
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.businessId = Util.safeString(pathParams.get('businessId'));
    this.locationId = Util.safeString(pathParams.get('locationId'));
  }

  public goToBusinessPage(): void {
    this.navigationService.goToBusinessPage(this.businessId)
  }

  public goToLocationPage(): void {
    this.navigationService.goToLocationPage(this.locationId)
  }

  public updateDownloadQrCodesActionUrl(): void {
    let subjectType = 'location';
    let subjectId = this.locationId;
    if (this.businessId){
      subjectType = 'business';
      subjectId = this.businessId;
    }

    // See com.waiternow.app.web.waiternow.controller.servlet.restful.user.pointofservice.GetQrCodesAction
    this.downloadQrCodesActionUrl = EnvironmentUtil.resolveBackendUrl('/service/user/qrcode/generate')
        + '/' + subjectType
        + '/' + this.qrCodeSizeField.value + '/' + this.languageField.value
        + '/' + this.themeField.value + '/' + subjectId;
  }
}
